import { gql } from '@/__generated__';

const GET_USER_PREFERENCES_VISIBLE_UNITS = gql(`#graphql
  query GetUserPreferencesVisibleUnits($id: Int) {
    user(id: $id) {
      id
      preferences {
        id
        visibleUnits
        defaultValues: visibleUnits(defaultValues: true)
      }
    }
  }
`);

export default GET_USER_PREFERENCES_VISIBLE_UNITS;
